import type { PositionalArgs } from 'ember-modifier'
import Modifier from 'ember-modifier'

interface Signature<T> {
  Element: Element // not required: it'll be set by default
  Args: {
    Positional: [functionToExecute: (watchedValue?: T) => void, watchedValue: T]
  }
}

/**
 * This modifier will call the provided function whenever the watchedValue args change.
 *
 * Template
 *
 * ```hbs
 * <div {{onChange this.changed this.watched}} />
 * ```
 *
 * `this.changed` will be executed each time `this.watched` is changed.
 *
 * It will *not* run on the first render.
 *
 * The provided function can optionally receive the watched value as an argument.
 *
 * `functionToExecute: (watchedValue?: T) => void,`
 *
 */
export class OnChange<T> extends Modifier<Signature<T>> {
  calls = 0

  modify(_element: HTMLElement, [functionToExecute, watchedValue]: PositionalArgs<Signature<T>>) {
    if (this.calls > 0) {
      functionToExecute(watchedValue)
    }

    this.calls++
  }
}

export default OnChange
